import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const transactionsURL = `${BASE_URL}/transactions`;

//Get all transactions
export const allTransactions=async (query)=>apiCallTemplate("get", `${transactionsURL}${query}`)

//Get Initialize subscription payment
export const initSubscriptionPayment=async (data)=>apiCallTemplate("post", `${transactionsURL}/initialize-payment`, data)

//Put User in free plan
export const switchUserToFreePlan=async (id)=>apiCallTemplate("get", `${transactionsURL}/get/free-plan/${id}`)

//Remove User in free plan
export const removeUserFromFreePlan=async (id)=>apiCallTemplate("get", `${transactionsURL}/remove/free-plan/${id}`)

//Get Transaction status
export const verifyTransaction=async (query)=>apiCallTemplate("get", `${transactionsURL}/check-payment?reference=${query}`)

//Get single transaction
export const myTransaction=async (id)=>apiCallTemplate("get", `${transactionsURL}/transaction-history`)

//Check user subscriptio status
export const mySubStatus=async (id)=>apiCallTemplate("get", `${transactionsURL}/check-subscription/${id}`)

//Get single transaction
export const singleTransaction=async (id)=>apiCallTemplate("get", `${transactionsURL}/${id}`)

//Mark transaction seen
export const markTransactionSeen=async (id, data)=>apiCallTemplate("put", `${transactionsURL}/mark-seen/${id}`, data)


//Get transaction statistics
export const transactionsStatistics=async (id)=>apiCallTemplate("get", `${transactionsURL}/get/statistics`)

